// extracted by mini-css-extract-plugin
export default {"wrapper":"StickyPageLayout_wrapper__AK57x","header":"StickyPageLayout_header__MnAsW","title":"StickyPageLayout_title__2XDgu","content":"StickyPageLayout_content__+xryl"};